module.exports = __webpack_public_path__ + "img/f44.4436640f.png";